import BiModule from './biModule'

export const instance = BiModule()
window.bi = instance
